import { actions, loaders, ProjectTag, projectStatusByCode } from 'entities';

import { Skeleton } from 'components/Blocks';

import { TagSelect } from '../TagSelect';

import { useUser } from 'hooks/user';
import { useProjectProfile } from '../context';

import { listGet, listRemove } from 'utils/array';

type SavedProjectTag = ProjectTag & { id: string };

export function ProjectTags() {
  const { project, updateProject } = useProjectProfile();

  const user = useUser();

  const canEdit = [
    user.id === project?.owner.id,
    user.type === 'LEADER' && user.team.id === project?.teamResponsible,
  ].some(Boolean);

  const { blocks } = projectStatusByCode[project.status];
  const isBlocked = !!(blocks?.fullBlock || blocks.tags);

  const tags = loaders.teams.projectTags.use({
    blockLoad: !canEdit || isBlocked,

    defaultValue: [],

    params: {
      teamId: user.team.id,
    },

    parser: (tags) => tags.filter((t) => !t.disabled),
  });

  const addTag = actions.projects.addProjectTag.use({
    onSuccess: (_, { tag }) =>
      updateProject((old) => ({
        ...old,
        tags: [...old.tags, listGet(tags.data, tag)!],
      })),
  });

  const removeTag = actions.projects.removeProjectTag.use({
    onSuccess: (_, { tag }) =>
      updateProject((old) => ({
        ...old,
        tags: listRemove(old.tags, tag),
      })),
  });

  const isLoading = !project || tags.errorOrLoading;

  const canAdd = [canEdit, !isBlocked].every(Boolean);

  return isLoading ? (
    <Skeleton width={110} height={30} />
  ) : (
    <TagSelect
      showAddButton={canAdd}
      tags={project.tags as SavedProjectTag[]}
      tagOptions={tags.data}
      onTagClick={({ id }) => addTag.execute({ project: project.id, tag: id })}
      deleteTag={(id) => removeTag.execute({ project: project.id, tag: id })}
    />
  );
}
